import React from 'react';
import { Text, TextMarkup } from '../../text/index';
import { is } from '../../../services/classify';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Breadcrumb Item Component
 * @param children {string} Breadcrumb Item Text
 * @param active {boolean} Active link
 * @param to {string} Url. Use React Router Link instead of a native <a> tag.
 * @param onClick {Function} Click Event
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param routerLink Custom Router Link as props
 * @param href {string} Url. Use native <a> tag (only when the `to` property is not filled)
 * @param className {string} Additionnal CSS Classes
 */
const BreadcrumbItem = ({ children, active, className, href, to, routerLink, testId, onClick, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(active && is('active'), className));
    if (routerLink && to) {
        const RouterLink = (routerLink ? routerLink : 'a');
        return (React.createElement("li", { "data-testid": testId, className: classes, onClick: onClick },
            React.createElement(RouterLink, { to: to, ...others }, children)));
    }
    return (React.createElement("li", { className: classes, onClick: onClick },
        React.createElement(Text, { markup: TextMarkup.A, href: href, ...others }, children)));
};
export default BreadcrumbItem;
//# sourceMappingURL=BreadcrumbItem.js.map